/**
 * GBA/ITC Gateway API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FacilityDto { 
    /**
     * Facility ID (DID format with fragment)
     */
    id: string;
    /**
     * Facility name
     */
    name: string;
    /**
     * Supply chain clusters for this facility
     */
    supplyChainClusters: Array<FacilityDto.SupplyChainClustersEnum>;
    /**
     * Facility location as GeoJSON string
     */
    location?: string;
}
export namespace FacilityDto {
    export const SupplyChainClustersEnum = {
        Mining: 'mining',
        Refining: 'refining',
        AdvancedMaterials: 'advanced-materials',
        BatteryComponents: 'battery-components',
        BatteryAssembly: 'battery-assembly'
    } as const;
    export type SupplyChainClustersEnum = typeof SupplyChainClustersEnum[keyof typeof SupplyChainClustersEnum];
}


